import { useMemo } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Main, Dashboard, Select } from "components";

import useGet from "hooks/useGet";
import useCreate from "hooks/useCreate";

import { ReactComponent as ProductIcon } from "icons/product.svg";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;

const BrandNew = ({ handleSubmit, change, pristine, history, invalid }) => {
  const { data: producers } = useGet({
    query: ["producers"],
    path: "/producers",
    context: "list",
    search: { per_page: 10_000 },
  });

  const { is_creating, create } = useCreate({
    path: "/brands",
    onSuccess: ({ id }) => {
      history.push(`/brands/${id}`);
    },
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["producer"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const producer_options = useMemo(() => {
    return producers?.map(({ id, name }) => ({ label: name, value: id }));
  }, [producers]);

  const onSubmit = (values) => create(values);

  return (
    <Main
      page={{
        name: "Dodaj markę",
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Marki",
            path: "/brands",
          },
          { name: "Dodaj markę" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard
            header={{ title: "Podstawowe informacje", icon: "info" }}
            footer={
              <>
                <Button type="cancel" onClick={() => history.push("/brands")} />
                <Button
                  type="save"
                  text={is_creating ? "Proszę czekać..." : "Utwórz"}
                  disabled={pristine || invalid || is_creating}
                  onClick={handleSubmit(onSubmit)}
                />
              </>
            }
          >
            <form
              className="dashboard__form"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <Field
                name="name"
                label="Nazwa"
                component={InputField}
                type="text"
              />
              <Field
                name="email"
                label="E-mail"
                component={InputField}
                type="text"
              />
              <Field
                label="Producent"
                name="producer_id"
                component={SelectField}
                options={producer_options}
                handleChange={(value) => {
                  change("producer_id", value);
                }}
              />
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Nazwa produktu jest wymagana!";
  }

  if (!values.producer_id) {
    errors.producer_id = "Producent jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "create-brand",
  enableReinitialize: true,
  validate,
})(BrandNew);
